<template>
  <v-form ref="productForm" v-model="valid" :lazy-validation="lazy">
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field name="productName" outlined dense label="Product Name *" v-model="record.Name" type="text"
          autocomplete="off" :rules="inputRules"></v-text-field>
      </v-col>

      <v-col cols="12" md="3" v-show="ExportsVersion != 'Y'">
        <v-text-field name="itemCode" outlined dense label="Item Code" v-model="record.ItemCode" type="text"
          autocomplete="off"></v-text-field>
      </v-col>

      <v-col cols="12" md="3" v-show="ExportsVersion == 'Y'">
        <v-text-field name="itemCode" outlined dense label="HS Code" v-model="record.ItemCode" type="text"
          autocomplete="off"></v-text-field>
      </v-col>

      <v-col cols="12" md="3" v-show="ExportsVersion != 'Y'">
        <v-text-field name="productName" outlined dense label="Barcode" v-model="record.BarCode" type="text"
          autocomplete="off"></v-text-field>
      </v-col>

      <v-col cols="12" md="6" v-show="ProductsHaveUom != 'Y'">
        <v-text-field outlined dense label="Description" v-model="record.Description" type="text"
          autocomplete="off"></v-text-field>
      </v-col>

      <v-col cols="12" md="3">
        <v-autocomplete @change="changeSelectedType(record.ItemType)" autocomplete="off" outlined dense
          v-model="record.ItemType" :items="itemTypes" item-text="name" item-value="value" label="Item Type"
          :rules="inputRules"></v-autocomplete>
      </v-col>

      <v-col cols="12" md="3">
        <v-autocomplete autocomplete="off" name="productCategoryCreate" hide-details dense outlined
          v-model="record.categoryId" :items="categories" label="Category" item-text="Name" item-value="id"
          :rules="inputRules">
          <template v-slot:no-data>
            <v-row align="center" justify="center">
              <v-btn class="ma-2" color="accent" dark small elevation="0" @click="categoryModal()">
                <v-icon left>mdi-plus</v-icon>Create Category
              </v-btn>
            </v-row>
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" md="3">
        <v-autocomplete autocomplete="off" name="productSubCategoryCreate" hide-details dense outlined
          v-model="record.subCategoryId" :items="subCategories" label="Sub Category" item-text="Name" item-value="id">
        </v-autocomplete>
      </v-col>

      <v-col cols="12" md="3">
        <v-autocomplete autocomplete="off" name="productMake" hide-details dense outlined v-model="record.makeId"
          :items="makes" label="Make" item-text="Name" item-value="id">
        </v-autocomplete>
      </v-col>

      <v-col cols="12" md="3">
        <v-autocomplete autocomplete="off" name="productModel" hide-details dense outlined v-model="record.modelId"
          :items="productModels" label="Model" item-text="Name" item-value="id">
        </v-autocomplete>
      </v-col>

      <v-col cols="12" md="3">
        <v-autocomplete autocomplete="off" name="productType" hide-details dense outlined v-model="record.productTypeId"
          :items="productTypes" label="Product Type" item-text="Name" item-value="id">
        </v-autocomplete>
      </v-col>

      <v-col cols="12" md="3">
        <v-autocomplete autocomplete="off" name="productBrand" hide-details dense outlined v-model="record.brandId"
          :items="brands" label="Brand" item-text="Name" item-value="id">
          <template v-slot:no-data>
            <v-row align="center" justify="center">
              <v-btn class="ma-2" color="accent" dark small elevation="0" @click="brandModal()">
                <v-icon left>mdi-plus</v-icon>Create Brand
              </v-btn>
            </v-row>
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" md="3">
        <v-autocomplete autocomplete="off" name="color" hide-details dense outlined v-model="record.colorId"
          :items="colors" label="Color" item-text="Name" item-value="id">
        </v-autocomplete>
      </v-col>

      <!-- <v-col cols="12" md="3">
        <v-text-field name="itemCode" outlined dense label="Year" v-model="record.Year" type="text"
          autocomplete="off"></v-text-field>
      </v-col>  -->

      <v-col cols="12" md="3" v-show="ProductsHaveUom != 'Y'">
        <v-text-field hide-details outlined dense label="Re Order Level" v-model="record.ReOrder" type="text"
          autocomplete="off"></v-text-field>
      </v-col>

      <v-col cols="12" md="3" v-show="ProductsHaveUom != 'Y'">
        <v-text-field hide-details outlined dense label="Production Variance %" v-model="record.VariancePerct"
          type="number" autocomplete="off"></v-text-field>
      </v-col>

      <v-col cols="12" md="3" v-show="ProductsHaveUom != 'Y'">
        <v-autocomplete autocomplete="off" name="owner" hide-details dense outlined v-model="record.Owner"
          :items="users" label="Owner" item-text="name" item-value="id"></v-autocomplete>
      </v-col>

      <v-col cols="12" md="3" v-show="ExportsVersion != 'Y'">
        <v-text-field name="requiredLinked" outlined dense label="Required Ui Linked Products"
          v-model="record.RequireLinked" type="number" autocomplete="off"></v-text-field>
      </v-col>

      <v-col cols="12" md="3">
        <v-checkbox color="accent" style="margin-top: 5px" v-model="NonVatable" hide-details outlined
          :label="`Non Vatable`"></v-checkbox>
      </v-col>



      <v-col cols="12" md="12">
        <v-checkbox style="margin-top: -2px"
          label="Define units of measure (uoms i.e gm, kgs, Dozen e.t.c) - active when creating only"
          v-model="HasUom"></v-checkbox>
      </v-col>
    </v-row>

    <v-divider></v-divider>

    <v-row class="mb-1 docForm subtitle-2 text--primary" v-show="HasUom == false">
      <v-col cols="12" sm="12" md="12">
        <!-- start of table -->
        <v-data-table :items-per-page="1000" :headers="pricelistHeaders" :items="priceLists" :search="search"
          hide-default-footer>
          <!-- buying price template -->
          <template v-slot:item.BuyingPrice="{ item }">
            <v-text-field style="width: 250px" class="orderInput" single-line dense outlined
              v-model="item.BuyingPrice"></v-text-field>
          </template>
          <!-- end -->

          <!-- selling price template -->
          <template v-slot:item.SellingPrice="{ item }">
            <v-text-field style="width: 250px" class="orderInput" single-line dense outlined
              v-model="item.SellingPrice"></v-text-field>
          </template>
          <!-- end -->

          <!-- least price template -->
          <template v-slot:item.LeastPrice="{ item }">
            <v-text-field style="width: 250px" class="orderInput" single-line dense outlined
              v-model="item.LeastPrice"></v-text-field>
          </template>
          <!-- end -->
        </v-data-table>
        <!-- end -->
      </v-col>
    </v-row>

    <v-divider></v-divider>

    <v-row v-if="HasUom == true" class="mt-2">
      <v-col cols="12" md="3">
        <v-autocomplete name="productBaseUom" outlined dense v-model="record.IUoMEntry" :items="uom" item-text="UomName"
          item-value="id" label="Base / inventory UOM (smallest unit)"
          :rules="HasUom ? [v => !!v || 'Field is required'] : []"></v-autocomplete>
      </v-col>

      <v-col cols="12" md="3">
        <v-autocomplete name="productPurchaseUom" outlined dense v-model="record.PUoMEntry" :items="uom"
          item-text="UomName" item-value="id" label="Default Purchase UOM"
          :rules="HasUom ? [v => !!v || 'Field is required'] : []"></v-autocomplete>
      </v-col>

      <v-col cols="12" md="3">
        <v-autocomplete name="SUoMEntry" dense outlined v-model="record.SUoMEntry" :items="uom" item-text="UomName"
          item-value="id" label="Default Sales UOM"
          :rules="HasUom ? [v => !!v || 'Field is required'] : []"></v-autocomplete>
      </v-col>

      <v-col cols="12" md="3">
        <v-autocomplete outlined dense readonly filled v-model="record.IUoMEntry" :items="uom" item-text="UomName"
          item-value="id" label="Inventory Uom"></v-autocomplete>
      </v-col>
    </v-row>

    <v-row class="mt-2" v-show="HasUom == true">
      <v-col cols="12">
        <v-btn text color="accent" class="float-right" @click.native="uomDialog = true">
          <v-icon>mdi-plus</v-icon>Add Uom / Prices
        </v-btn>
      </v-col>

      <v-col cols="12">
        <v-data-table :items-per-page="2000" :headers="headers" :items="uomArray" :mobile-breakpoint="0"
          hide-default-footer>
          <!-- action template -->
          <template v-slot:item.BaseQty="{ item }">
            <span v-show="docCreate == true">{{ item.BaseQty }}</span>
            <span v-show="docCreate == false">{{ item.BaseQty }}</span>
          </template>
          <!-- end -->

          <!-- action template -->
          <template v-slot:item.action="{ item }">
            <v-btn v-show="docCreate == true" color="red" text icon @click="deleteUom(item)">
              <v-icon>mdi-close</v-icon>
            </v-btn>

            <v-btn v-show="docCreate == false" color="primary" text icon>
              <v-btn color="accent" text icon @click="openEditModal(item)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </v-btn>
          </template>
          <!-- end -->

          <!-- action template -->
          <template v-slot:item.delete="{ item }">
            <v-btn v-show="docCreate == false" color="red" text icon @click="openDeleteUomModal(item)">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
          <!-- end -->
        </v-data-table>
      </v-col>
    </v-row>

    <v-row class="subtitle-2 text--primary" v-show="ExportsVersion != 'Y'">
      <v-col cols="12">
        <span class="style-16 pa-2">Link service with inventory items</span>
      </v-col>

      <v-col cols="12">
        <v-btn text v-if="docCreate == true" color="accent" @click.native="productLinkingDialog = true">
          <v-icon left>mdi-plus</v-icon> Link With Stock Item
        </v-btn>
      </v-col>

      <v-col cols="12" v-if="docCreate == true">
        <v-data-table :items-per-page="10" :mobile-breakpoint="0" :headers="linkedProductsHeaders"
          :items="linkedProducts" :search="search">
          <template v-slot:item.action="{ item }">
            <v-btn color="red" icon @click="removeLinkedProduct(item)">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-col>

      <v-col cols="12" v-if="docCreate == false">
        <v-data-table :items-per-page="10" :mobile-breakpoint="0" :headers="linkedHeaders"
          :items="linkedServiceProducts" :search="search">
        </v-data-table>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-btn v-if="docCreate == true" color="primary" @click="sendData" :loading="$store.state.btnLoader">
          <v-icon left>mdi-content-save</v-icon>Save
        </v-btn>

        <v-btn v-else color="primary" @click="sendData" :loading="$store.state.btnLoader">
          <v-icon left>mdi-content-save</v-icon>Update
        </v-btn>
      </v-col>
    </v-row>

    <!-- Delete db uom dialog -->
    <v-dialog v-model="deleteUomDialog" max-width="750px">
      <v-card>
        <v-toolbar dense color="secondary" flat>
          <v-toolbar-title>Delete Product Uom</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="deleteUomDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-container fluid class="subtitle-2 text--primary">
            <v-row>


              <v-col cols="12">
                <div>
                  <span class="style-16">Are you sure you want to delete this uom ? </span> - <span class="style-16"
                    style="color: red"> {{ uomItem.UomName }}</span>
                </div>

              </v-col>

              <v-col cols="12">
                <v-btn color="red" dark @click="deleteAddedUom" :loading="loader" class="float-right">
                  <v-icon left>mdi-delete</v-icon> Delete Uom
                </v-btn>
              </v-col>

            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of deleting added uom  modal-->


    <!-- Product Linking dialog -->
    <v-dialog v-model="productLinkingDialog" max-width="750px">
      <v-card>
        <v-toolbar dense color="secondary" flat>
          <v-toolbar-title>Product Linking </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="productLinkingDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-container fluid class="subtitle-2 text--primary">
            <v-row>
              <v-col cols="12" xs="12" md="8">
                <v-autocomplete style="width: 500px" autocomplete="off" v-model="linkedItem.productId" :items="products"
                  :search-input.sync="searchProducts" item-text="Name" item-value="id" cache-items flat hide-no-data
                  hide-details label="Search Product" outlined dense>
                </v-autocomplete>
              </v-col>

              <v-col cols="12" xs="12" md="4">
                <v-text-field autocomplete="off" type="number" v-model="linkedItem.quantity"
                  label="Consumption Quantity" outlined dense></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-checkbox label="Show on sale UI" v-model="ShowOnSaleUi"></v-checkbox>
              </v-col>

              <v-col cols="12">
                <v-btn color="accent" @click="linkProduct" small :loading="loader" class="float-right">
                  <v-icon left>mdi-plus</v-icon> Link Product To Service
                </v-btn>
              </v-col>

            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of product linking modal-->


    <!-- category quick add dialog -->
    <v-dialog v-model="categoryDialog" max-width="650px">
      <v-card>
        <v-toolbar dense color="primary" dark>
          <v-toolbar-title>Create Category</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="categoryDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <category-editor :initial="newItem" @data="saveCategory"></category-editor>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of modal-->

    <!-- brand quick add dialog -->
    <v-dialog v-model="brandDialog" max-width="650px">
      <v-card>
        <v-toolbar dense color="primary" dark>
          <v-toolbar-title>Create Brand</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="brandDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <brand-editor :initial="newItem" @data="saveBrand"></brand-editor>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of modal-->

    <!-- Balance dialog -->
    <v-dialog v-model="uomDialog" max-width="850">
      <v-form ref="addUomForm">
        <v-card>
          <v-toolbar dense color="accent" dark>
            <v-toolbar-title>Add Uom Setup</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="uomDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container fluid class="subtitle-2 text--primary">
              <v-row>
                <v-col cols="12" md="4">
                  <v-autocomplete outlined name="newDefUomEntry" v-model="uomItem.uomEntry" :items="uom"
                    item-text="UomName" item-value="id" label="UoM Name" @change="checkUom(uomItem.uomEntry)"
                    :rules="inputRules"></v-autocomplete>
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field hide-details outlined dense label="Buying Price (or zero)" v-model="uomItem.BuyingPrice"
                    type="number" autocomplete="off" :rules="inputRules"></v-text-field>
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field hide-details outlined dense label="Selling Price (or zero)"
                    v-model="uomItem.SellingPrice" type="number" autocomplete="off" :rules="inputRules"></v-text-field>
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field hide-details outlined dense label="Least Selling Price (or Zero)"
                    v-model="uomItem.LeastPrice" type="number" autocomplete="off" :rules="inputRules"></v-text-field>
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field hide-details outlined dense
                    :filled="record.IUoMEntry == uomItem.uomEntry ? true : false"
                    :readonly="record.IUoMEntry == uomItem.uomEntry ? true : false" label="Pack Size (smallest unit)"
                    v-model="uomItem.BaseQty" type="number" autocomplete="off" :rules="inputRules"></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-btn v-if="docCreate == true" color="primary" @click="addUom" :loading="loader">
                    <v-icon left>mdi-plus</v-icon>Add Uom
                  </v-btn>

                  <v-btn v-if="docCreate == false" color="primary" @click="addNewUom" :loading="loader">
                    <v-icon left>mdi-plus</v-icon>Add Uom
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>
    <!-- end of balance modal-->

    <!-- editing dialog -->
    <v-dialog v-model="editingDialog" max-width="750px">
      <v-form ref="uomEditForm">
        <v-card>
          <v-toolbar dense color="secondary" flat>
            <v-toolbar-title>Edit Group Definition</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="editingDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container fluid>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="12">
                  <span class="style-18">{{ uomItem.UomName }}</span>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-text-field type="number" label="Buying Price" outlined dense v-model="uomItem.BuyingPrice"
                    :rules="inputRules"></v-text-field>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-text-field type="number" label="Selling Price" outlined dense v-model="uomItem.SellingPrice"
                    :rules="inputRules"></v-text-field>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-text-field label="Least Selling Price" outlined dense v-model="uomItem.LeastPrice" type="number"
                    :rules="inputRules"></v-text-field>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-text-field :filled="record.IUoMEntry == uomItem.uomEntry ? true : false"
                    :readonly="record.IUoMEntry == uomItem.uomEntry ? true : false" label="Pack Size" outlined dense
                    v-model="uomItem.BaseQty" type="number" :rules="inputRules"></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-btn color="primary" @click="updateDef" :loading="$store.state.btnLoader">
                    <v-icon left>mdi-content-save</v-icon>Update
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>
    <!-- end of editing dialog -->

    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-form>
</template>


<script>
import CategoryEditor from "@/components/subscriber/products/categories/_components/quick-editor.vue";
import BrandEditor from "@/components/subscriber/products/brands/_components/quick-editor.vue";
export default {
  computed: {
    ExportsVersion() {
      return localStorage.getItem("ExportsVersion");
    },
  },
  components: {
    CategoryEditor,
    BrandEditor,
  },
  props: {
    initial: {
      type: Object,
      required: true
    },
    docCreate: {
      type: Boolean
    },
    linkedServiceProducts: {
      type: Array
    }
  },
  data: () => ({
    deleteUomDialog: false,
    ShowOnSaleUi: false,
    selectedServiceType: "I",
    linkedItem: {},
    productLinkingDialog: false,
    linkedProductId: null,
    searchProducts: null,
    width: "200px",
    height: "150px",
    mode: "SVG",
    type: "Ean8",
    valid: false,
    lazy: false,
    ProductsHaveUom: "N",
    inputRules: [v => !!v || "Required"],
    record: {},
    search: "",
    HasUom: false,
    uomItem: {},
    products: [],
    uomArray: [],
    linkedProducts: [],
    NonVatable: false,
    users: [],
    makes: [],
    productModels: [],
    productTypes: [],
    colors: [],
    uomDialog: false,
    searchingProduct: true,
    enableCreate: true,
    categoryDialog: false,
    brandDialog: false,
    BuyingPrice: null,
    SellingPrice: null,
    newItem: {},
    editItem: {},
    editingDialog: false,
    loader: false,
    PriceUnit: null,
    categories: [],
    subCategories: [],
    industries: [],
    showPricing: false,
    manualStatus: false,
    activeUom: null,
    uom: [],
    uoms: [],
    ougp: [],
    brands: [],
    stores: [],
    vendors: [],
    priceLists: [],
    store: null,
    date: new Date().toISOString().substr(0, 10),
    linkedProductsHeaders: [
      { text: "Product Name", value: "name" },
      { text: "Quantity", value: "quantity" },
      { text: "Show on sale ui", value: "showOnSaleUi" },
      { text: "Action", value: "action" }
    ],
    linkedHeaders: [
      { text: "Product Name", value: "product.Name" },
      { text: "Quantity", value: "quantity" },
      { text: "Show on sale ui", value: "ShowOnSaleUi" },
    ],
    itemTypes: [
      { name: "Inventory", value: "I" },
      { name: "Service Item", value: "S" },
      { name: "Delivery Charges", value: "C" }
    ],
    headers: [
      { text: "Uom Unit", value: "UomName" },
      { text: "Buying Price", value: "BuyingPrice" },
      { text: "Selling Price", value: "SellingPrice" },
      { text: "Least Price", value: "LeastPrice" },
      { text: "Pac size", value: "BaseQty" },
      { text: "Action", value: "action" },
      { text: "Delete", value: "delete" }
    ],
    pricelistHeaders: [
      { text: "Price List", value: "Name", sortable: false },
      { text: "Buying price", value: "BuyingPrice", sortable: false },
      { text: "Selling Price", value: "SellingPrice", sortable: false },
      { text: "Least Price", value: "LeastPrice", sortable: false }
    ]
  }),
  watch: {
    initial: {
      handler: "init",
      immediate: true
    },
    searchProducts(val) {
      if (val && val !== this.select && this.querySelections(val)) {
        this.querySelections(val);
      }
    },
  },
  methods: {
    changeSelectedType(data) {
      this.selectedServiceType = data;
    },
    init(val) {
      if (this.docCreate == false) {
        const hasUom = val.HasUom;
        if (hasUom === 1) {
          this.showPricing = false;
          this.HasUom = true;
          this.uomArray = val.ugp1;
        } else {
          this.priceLists = val.prices;
          this.CanUpdateBuyingPrice = val.CanUpdateBuyingPrice == "Y" ? true : false;
          this.NonVatable = val.NonVatable == "Y" ? true : false;
          this.showPricing = true;
          this.HasUom = false;
        }
      }
      this.record = { ...val };
    },
    linkProduct() {
      const self = this;

      if (self.linkedItem.productId == undefined || self.linkedItem.quantity == undefined) {
        this.$refs.snackbar.show("Please fill in the fields !", "red");
        return;
      }

      var productId = self.linkedItem.productId;

      // get product name
      var product = self.products.find((record) => {
        return record.id === productId;
      });

      var showOnUi = this.ShowOnSaleUi ? "Y" : "N";

      var data = {
        "productId": parseInt(self.linkedItem.productId),
        "name": product.Name,
        "quantity": parseFloat(self.linkedItem.quantity),
        "showOnSaleUi": showOnUi
      };

      var initArray = [];
      initArray.push(data);

      this.linkedProducts = [...this.linkedProducts, ...initArray];

      this.linkedItem = {};
      this.productLinkingDialog = false
      this.$refs.snackbar.show("added to list", "green");
    },
    querySelections(searchText) {
      const self = this;
      const url = "/products/search";

      var customerId = 0;

      const data = {
        SearchText: searchText,
        CustomerId: customerId
      };

      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            if (res.ResponseData != null) {
              self.products = res.ResponseData;
            }
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    checkUom(id) {
      if (id == this.record.IUoMEntry) {
        this.uomItem.BaseQty = 1;
      } else {
        this.uomItem.BaseQty = "";
      }
    },
    openDeleteUomModal(data) {
      this.uomItem = data;
      this.deleteUomDialog = true;
    },
    openEditModal(data) {
      this.uomItem = data;
      this.editingDialog = true;
    },
    addUom() {
      if (!this.$refs.addUomForm.validate()) {
        this.$refs.snackbar.show("Please fill all the fields", "red");
        return;
      }

      var inventoryUom = this.record.IUoMEntry;
      var baseRecord = this.uomArray.find(x => x.uomId == inventoryUom);

      var uomEntry = this.uomItem.uomEntry;
      var uomRecord = this.uom.find(x => x.id == uomEntry);

      if (baseRecord == undefined && uomRecord.id != inventoryUom) {
        this.$refs.snackbar.show(
          "Please define uom setup for the base unit first",
          "red"
        );
        return;
      }

      // ensure that the base qty for the inventory uom is 1
      if (uomRecord.id == inventoryUom && this.uomItem.BaseQty != 1) {
        this.$refs.snackbar.show(
          "Base qty for the inventory uom must be 1",
          "red"
        );
        return;
      }

      this.uomItem.uomName = uomRecord.UomName;

      var uomDetails = {
        uomId: uomRecord.id,
        UomEntry: uomRecord.id,
        AltQty: 1,
        UomName: uomRecord.UomName,
        BaseQty: parseFloat(this.uomItem.BaseQty),
        BuyingPrice: parseFloat(this.uomItem.BuyingPrice),
        SellingPrice: parseFloat(this.uomItem.SellingPrice),
        LeastPrice: parseFloat(this.uomItem.LeastPrice)
      };

      this.uomArray.push(uomDetails);
      this.uomItem = {};
      this.uomDialog = false;
    },
    addNewUom() {
      if (!this.$refs.addUomForm.validate()) {
        this.$refs.snackbar.show("Please fill all the fields", "red");
        return;
      }

      var uomEntry = this.uomItem.uomEntry;
      var existingRecord = this.uomArray.find(x => x.UomEntry == uomEntry);

      if (existingRecord != undefined) {
        this.$refs.snackbar.show("Uom already added", "red");
        return;
      }

      const data = {
        UgpEntry: this.record.UgpEntry,
        UomEntry: this.uomItem.uomEntry,
        AltQty: 1,
        BaseQty: parseFloat(this.uomItem.BaseQty),
        BuyingPrice: parseFloat(this.uomItem.BuyingPrice),
        SellingPrice: parseFloat(this.uomItem.SellingPrice),
        LeastPrice: parseFloat(this.uomItem.LeastPrice)
      };

      const url = "/ugp1";
      this.loader = true;
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res["ResultCode"] == 1200) {
            location.reload();
          } else {
            self.loader = false;
            this.$refs.snackbar.show(res["ResultDesc"], "red");
          }
          // location.reload();
        })
        .catch(() => { });
    },
    updateDef() {
      if (!this.$refs.uomEditForm.validate()) {
        this.$refs.snackbar.show("Please fill all the fields", "red");
        return;
      }

      // you cannot edit the inventory uom unit if base qty != 1
      if (this.uomItem.UomEntry == this.record.IUoMEntry && this.uomItem.BaseQty != 1) {
        this.$refs.snackbar.show(
          "Quantity for the inventory unit must be 1",
          "red"
        );
        return;
      }

      var data = {
        UgpEntry: this.record.UgpEntry,
        UomEntry: this.uomItem.UomEntry,
        AltQty: 1,
        BaseQty: parseFloat(this.uomItem.BaseQty),
        BuyingPrice: parseFloat(this.uomItem.BuyingPrice),
        SellingPrice: parseFloat(this.uomItem.SellingPrice),
        LeastPrice: parseFloat(this.uomItem.LeastPrice)
      };

      const url = "/ugp1/edit";
      // const self = this;
      this.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            location.reload();
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
            this.loader = false;
          }
        })
        .catch(() => { });
    },
    deleteUom(item) {
      var index = this.uomArray.indexOf(item);
      if (index == -1) {
        return;
      }

      this.uomArray.splice(index, 1);
    },
    removeLinkedProduct(item) {
      var index = this.linkedProducts.indexOf(item);
      if (index == -1) {
        return;
      }

      this.linkedProducts.splice(index, 1);
    },
    categoryModal() {
      this.categoryDialog = true;
    },
    brandModal() {
      this.brandDialog = true;
    },
    saveBrand(data) {
      const url = "/brands";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.$store.commit("btnLoader", false);
            self.brands = [...this.brands, res.ResponseData];
            self.record.brand_id = res.ResponseData.id;
            self.$refs.snackbar.show("Brand Added Successully", "green");
            self.brandDialog = false;
            self.getCategories();
          } else {
            self.$store.commit("btnLoader", false);
            self.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    saveCategory(data) {
      const url = "/products-categories";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.categories = [...this.categories, res.ResponseData];
            self.record.categoryId = res.ResponseData.id;
            self.$refs.snackbar.show("Category Added Successully", "green");
            self.$store.commit("btnLoader", false);
            self.categoryDialog = false;
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    setDate(date) {
      this.record.date = date;
    },
    sendData() {
      if (!this.$refs.productForm.validate()) {
        this.$refs.snackbar.show("Please fill all the fields", "red");
        return;
      }

      if (this.docCreate == true) {
        var uomRecord = {};
        var message = "";
        // check if the inventory uom definition exist in the uom array
        if (this.HasUom == true) {
          var inventoryUom = this.record.IUoMEntry;
          var baseRecord = this.uomArray.find(x => x.uomId == inventoryUom);
          uomRecord = this.uom.find(x => x.id == inventoryUom);
          var uomName = uomRecord.UomName;
          message = `Please define uom setup for the base unit (${uomName})`;
          if (baseRecord == undefined) {
            this.$refs.snackbar.show(
              "Please define uom setup for the base / inventory unit",
              "red"
            );
            return;
          }
        }

        // check if purchase uom definition exist in the uom array
        if (this.HasUom == true) {
          var purchaseUom = this.record.PUoMEntry;
          var purchaseRecord = this.uomArray.find(x => x.uomId == purchaseUom);
          uomRecord = this.uom.find(x => x.id == purchaseUom);
          uomName = uomRecord.UomName;
          message = `Please define uom setup for the purchase unit (${uomName})`;
          if (purchaseRecord == undefined) {
            this.$refs.snackbar.show(message, "red");
            return;
          }
        }

        // check if sale uom definition exist in the uom array
        if (this.HasUom == true) {
          var saleUom = this.record.SUoMEntry;
          var saleRecord = this.uomArray.find(x => x.uomId == saleUom);
          uomRecord = this.uom.find(x => x.id == saleUom);
          uomName = uomRecord.UomName;
          message = `Please define uom setup for the sale unit (${uomName})`;
          if (saleRecord == undefined) {
            this.$refs.snackbar.show(message, "red");
            return;
          }
        }
      }

      this.record.Taxable = "Y";
      this.record.HasUom = this.HasUom == true ? 1 : 0;
      this.record.NonVatable = this.NonVatable ? "Y" : "N";

      var pricesArray = [];
      // loop through the price list
      if (this.record.HasUom == false) {
        this.priceLists.forEach(element => {
          var priceList = {
            id: element.id,
            PricelistId: parseInt(element.id),
            BuyingPrice: element.BuyingPrice
              ? parseFloat(element.BuyingPrice)
              : 0,
            SellingPrice: element.SellingPrice
              ? parseFloat(element.SellingPrice)
              : 0,
            LeastPrice: element.LeastPrice ? parseFloat(element.LeastPrice) : 0
          };

          pricesArray.push(priceList);
        });

        this.record.prices = pricesArray;
      }

      this.record.ugp1 = this.uomArray;
      this.record.VariancePerct = parseFloat(this.record.VariancePerct);
      this.record.ItemCode = this.record.ItemCode;
      this.record.RequireLinked = parseInt(this.record.RequireLinked);
      this.record.LinkedProductsRequest = this.linkedProducts;


      this.$store.commit("btnLoader", true);
      this.$emit("data", this.record);
    },
    setSVolume(id) {
      const data = this.uoms.find(record => {
        return record.UomEntry === id;
      });
      this.record.SVolume = data.BaseQty;
    },
    setSalUnitMsr(id) {
      const data = this.uoms.find(record => {
        return record.UomEntry === id;
      });
      this.record.NumInSale = data.BaseQty;
    },
    setInvntryUom(id) {
      const data = this.uoms.find(record => {
        return record.UomEntry === id;
      });
      this.record.NumInCnt = data.BaseQty;
    },
    setBuyUnitMsr(id) {
      const data = this.uoms.find(record => {
        return record.UomEntry === id;
      });
      this.record.NumInBuy = data.BaseQty;
    },
    CheckUoMGroup(id) {
      const uomGroup = this.ougp.find(record => {
        return record.id === id;
      });
      const self = this;
      if (uomGroup.UgpName === "Manual") {
        self.showPricing = false;
        self.manualStatus = true;
      } else {
        this.loading = true;
        this.$store
          .dispatch("get", `/ougp/${id}`)
          .then(res => {
            self.uoms = res.ResponseData.groupDef;
            self.showPricing = true;
            self.manualStatus = false;
            self.record.SalUnitMsr = null;
            self.loading = false;
          })
          .catch(err => {
            this.$refs.snackbar.show(err, "red");
          });
      }
    },
    getCategories() {
      const self = this;
      this.$store
        .dispatch("get", `/products-categories`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.categories = res.ResponseData;
            if (self.docCreate == true) {
              self.record.categoryId = self.categories[0].id;
            }

            self.record.ItemType = "I";
            self.getGenSettings();
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getSubCategories() {
      const self = this;
      this.$store
        .dispatch("get", `/sub-categories`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.subCategories = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getSuppliers() {
      const self = this;
      this.$store
        .dispatch("get", `/suppliers`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.vendors = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getUom() {
      const self = this;
      this.$store
        .dispatch("get", `/uoms`)
        .then(res => {
          self.uom = res.ResponseData;
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    deleteAddedUom() {
      var id = this.uomItem.id;
      this.loader = true;
      const self = this;
      this.$store
        .dispatch("get", `/delete-ugp1-record/${id}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            location.reload();
          } else {
            self.loader = false;
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          self.loader = false;
          this.$refs.snackbar.show(err, "red");
        });
    },
    getOwners() {
      const self = this;
      this.$store
        .dispatch("get", `/users`)
        .then(res => {
          self.users = res.ResponseData;
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getMakes() {
      const self = this;
      this.$store
        .dispatch("get", `/product-makes`)
        .then(res => {
          self.makes = res.ResponseData;
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getModels() {
      const self = this;
      this.$store
        .dispatch("get", `/product-models`)
        .then(res => {
          self.productModels = res.ResponseData;
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getProductTypes() {
      const self = this;
      this.$store
        .dispatch("get", `/product-types`)
        .then(res => {
          self.productTypes = res.ResponseData;
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getBrands() {
      const self = this;
      this.$store
        .dispatch("get", `/brands`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.brands = res.ResponseData;
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getColors() {
      const self = this;
      this.$store
        .dispatch("get", `/colors`)
        .then(res => {
          self.colors = res.ResponseData;
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getPriceLists() {
      if (this.docCreate == false) {
        return;
      }

      const self = this;
      this.$store
        .dispatch("get", `/product-price-lists`)
        .then(res => {
          self.priceLists = res.ResponseData;
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getGenSettings() {
      const self = this;
      this.$store
        .dispatch("get", `/general-settings`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            if (res.ResponseData) {
              self.ProductsHaveUom = res.ResponseData.ProductsHaveUom;
              if (res.ResponseData.ProductsHaveUom == 'Y') {
                self.HasUom = true;
              }
            }
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    Promise.all([
      this.getSuppliers(),
      this.getUom(),
      this.getCategories(),
      this.getSubCategories(),
      this.getOwners(),
      this.getPriceLists(),
      this.getMakes(),
      this.getModels(),
      this.getProductTypes(),
      this.getColors(),
      this.getBrands()
    ]);
  }
};
</script>

<style scoped>
@media print {
  @page {
    margin: 0;
    /* This ensures that the default margin for the printed page is removed */
  }

  body * {
    visibility: hidden;
  }

  #printableSection,
  #printableSection * {
    visibility: visible;
  }

  #printableSection {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 10;
    /* Adjusted to fit the content */
    margin: 0;
    /* Remove any default margin */
    padding: 0;
    /* Remove any default padding */
    overflow: visible;
    /* Ensure that no content is clipped */
  }
}
</style>